
<div class="container-fluid">

  <div class="row mt-4 pb-5">

      @for (provider of emissionFactorProviders; track provider) {
        <div class="row mt-5">
          <!-- Target title + radio button -->
          <div class="col-12 target-title">
            <input
              class="form-check-input"
              [name]="objectiveType + 'choice'"
              type="radio"
              [value]="provider.id"
              [checked]="selectedProviderId === provider.id"
              (change)="providerChanged(provider.id)"
              [disabled]="(canEdit$ | async) === false || (provider.id === -1 && (isSiteObjectiveDisabled$ | async))"
            >
              @if (provider.id === 0) {
                <span>{{ provider.name | translate }}</span>
              }
              @if (provider.id === -1) {
                <span>{{ "Site objectives per building" | translate }}</span>
                <span class="objective-hint">{{ "Site objectives per building hint" | translate }}</span>
              }
              @if (provider.id > 0) {
                <span>{{ "Objectives by type of activity" | translate }} <span class="provider-name">({{ provider.name }})</span></span>
              }
          </div>
          <!-- Pathways table (If not corporate objective) -->
          @if (provider.id > 0) {
            <div class="col-12 mt-4 px-0 table-wrapper">

              <table class="table table-hover">
                <thead>
                  <tr>
                    @if (objectiveType === 'energy') {
                      <th scope="col" class="first-col">{{ "pages.energy.kwh_m2_year" | translate }}</th>
                    }
                    @if (objectiveType === 'carbon') {
                      <th scope="col" class="first-col">{{ "kg_eq_CO2_m2_year_alt" | translate }}</th>
                    }
                    @for (year of years; track years) {
                      <th class="centered-cell">{{ year }}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (item of ToUPathway; track ToUPathway) {
                    <tr (click)="selectToU(item)" [class]="item.name === selectedToUPathway.name ? 'selected' : 'not-selected'">
                      <td  class="first-col" [class]="item.name === selectedToUPathway.name ? 'selected-f-col' : 'not-selected-f-col'">
                        {{ item.name }}
                        @if (item.name === selectedToUPathway.name) {
                          <span class="check-icon">
                            <i class="fa-light fa-check"></i>
                          </span>
                        }
                      </td>
                      @if (objectiveType === 'energy') {
                        @for (consumption of item.consumption; track consumption) {
                          <td class="centered-cell">{{ (consumption| number:'1.0-0':'fr-FR') || '-'}}</td>
                        }
                      }
                      @if (objectiveType === 'carbon') {
                        @for (emission of item.emission; track emission) {
                          <td class="centered-cell">{{ (emission | number:'1.1-1':'fr-FR') || '-'}}</td>
                        }
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else if (provider.id === -1) {
            <app-corporate-pathways [objectiveType]="objectiveType"></app-corporate-pathways>
          }
        </div>
      }
    </div>

